import { connect } from 'react-redux';

import Options from './Options';

import { 
  setCountry, 
  setDesignStandard, 
  setProfileType, 
  setLanguage, 
  setActiveTab, 
  setAppStatus, 
  setUserProfile, 
  forceRevalidation, 
  setCountryUnits,
  setProjectName,
  // setExtendTimeout
} from '@reducers/actions';
import { updateClientUnits } from '@reducers/web-services/report/actions';
import { hide3DDimensions, show3DDimensions } from '@reducers/options/actions';

const mapState = state => ({
  localization: state.main.localization,
  appStatus: state.main.status,
  userProfile: state.main.userProfile,
  projectName: state.main.projectName,
  // extendTimeout: state.main.extendTimeout
});

const mapDispatch = dispatch => ({
  setLocalization: (options) => {
    dispatch(setCountry(options.country)); // set the country first in order to reset the units
    dispatch(setDesignStandard(options.designStandard));
    dispatch(setProfileType(options.profileType));
    dispatch(setLanguage(options.language));
    dispatch(updateClientUnits()); // VladP: We must change the client's units on the service as well
  },
  setActiveTab: (tab) => { dispatch(setActiveTab(tab)); },
  setAppStatus: (status) => { dispatch(setAppStatus(status)); },
  setUserProfile: (userProfile) => { dispatch(setUserProfile(userProfile)); },
  setLanguage: (language) => { dispatch(setLanguage(language)); },
  forceRevalidation: () => { dispatch(forceRevalidation()); },
  setCountryUnits: (country) => { dispatch(setCountryUnits(country)); },
  setProjectName: (projectName) => { dispatch(setProjectName(projectName)); },
  // setExtendTimeout: (shouldExtend) => { dispatch(setExtendTimeout(shouldExtend)); },
  show3DDimensions: () => { dispatch(show3DDimensions()); },
  hide3DDimensions: () => { dispatch(hide3DDimensions()); }
});

export default connect(mapState, mapDispatch)(Options);



// WEBPACK FOOTER //
// ./src/views/Options/index.js